import { render, staticRenderFns } from "./recMotionData.vue?vue&type=template&id=5892baca&"
import script from "./recMotionData.vue?vue&type=script&lang=js&"
export * from "./recMotionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports